import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Logout as IconLogout, Menu as IconMenu } from '@mui/icons-material';
import {
	AppBar,
	Box,
	Toolbar,
	Typography,
	IconButton,
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Divider,
} from '@mui/material';
import { thunkToAction } from 'typescript-fsa-redux-thunk';

import { URLS } from '@constants';

import { authLogout, authUserSelector } from '@redux';

export const TopMenu = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const user = useSelector(authUserSelector);
	const [isOpen, setIsOpen] = useState(false);

	const toggleDrawer = (open: boolean) => () => {
		setIsOpen(open);
	};

	const goTo = (url: string) => () => {
		navigate(url);
		setIsOpen(false);
	};

	const onLogout = async () => {
		setIsOpen(false);
		await dispatch(thunkToAction(authLogout.action)());
	};

	const handleLogout = () => {
		void onLogout();
	};

	const menuItems = [
		{ label: 'Главная', url: URLS.MAIN },
		{ label: 'Меню', url: URLS.MENU },
		{ label: 'Каталог блюд', url: URLS.CATALOG },
		{ label: 'Графики', url: URLS.GRAPHS },
		{ label: 'Настройки', url: URLS.SETTINGS },
	];

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position="static">
				<Toolbar>
					<IconButton
						size="large"
						edge="start"
						color="inherit"
						aria-label="menu"
						sx={{ mr: 2 }}
						onClick={toggleDrawer(true)}
					>
						<IconMenu />
					</IconButton>
					<Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />
					<Typography variant="subtitle1" component="div">
						{user?.login}
					</Typography>
				</Toolbar>
			</AppBar>

			<Drawer anchor="left" open={isOpen} onClose={toggleDrawer(false)}>
				<Box sx={{ width: 250 }} role="presentation">
					<List>
						{menuItems.map((item) => (
							<ListItem key={item.url} disablePadding>
								<ListItemButton onClick={goTo(item.url)}>
									<ListItemText primary={item.label} />
								</ListItemButton>
							</ListItem>
						))}

						<Divider />

						<ListItem disablePadding>
							<ListItemButton onClick={handleLogout}>
								<ListItemIcon>
									<IconLogout />
								</ListItemIcon>
								<ListItemText primary="Выход" />
							</ListItemButton>
						</ListItem>
					</List>
				</Box>
			</Drawer>
		</Box>
	);
};
